export default {
	tabs: ["Wycofaj", "Historia"],
	History: {
		tabs: ["Weryfikacja", "Sukces", "Odrzucenie"]
	},
	Withdraw: {
		label: ["Numer konta", "Nr zamówienia", "Adres", "Kwota", "Opłata", "Utworzono w", "Status", "Powód"]
	},
	AccountAmount: "Kwota konta",
	tips: "Wypłatę otrzymasz w ciągu godziny ",
	form: {
		label: ["Kwota wypłaty", "Hasło transakcji"],
		ALL: "WSZYSTKO",
		Withdraw: "Przedkładać"
	},
	WithdrawAccount: "Wycofaj konto",
	noAccountsTips: "Proszę dodać Metody Płatności",
	tradingKind: [
		"Zwrot gotówki",
		"Potrącenie",
		"Doładowanie",
		"Wypłata w toku",
		"Odmrożenie wypłaty",
		"Wypłata",
		"Zadanie",
		"Zwrot kapitału",
		"Zwrot prowizji",
		"Zwrot prowizji podległej",
		"Check-in",
		"Opłata manipulacyjna",
		"Depozyt",
		"Nagroda",
		"Wynagrodzenie podstawowe",
		"Pomoc gotówkowa",
		"Bonus rejestracyjny",
		"Dywidendy towarowe",
		"Bonus za zadanie",
		"Inne",
		"",
		"Bonus za pracę",
		"Nagrody za ulepszenie",
		"Dotacja",
		"Weryfikacja w toku",
		"Kampania",
		"Wymiana punktów",
		"Nagrody za logowanie",
		"Nagrody za pracę",
		"Transakcja punktów kredytowych"
	]
};
